import WorkTimeSettings from './WorkTimeSettings';

export default WorkTimeSettings;
